import { render } from "./specificGift_setting.vue?vue&type=template&id=6796dc1a"
import script from "./specificGift_setting.vue?vue&type=script&lang=js"
export * from "./specificGift_setting.vue?vue&type=script&lang=js"
script.render = render

export default script